import { isNull, isUndefined } from 'lodash-es'

export function deepCompare(obj1: any, obj2: any): boolean {
  const stack = [[obj1, obj2]]

  while (stack.length) {
    const [a, b] = stack.pop() as any[]

    if (a === b) continue

    if (
      typeof a !== 'object' ||
      a === null ||
      typeof b !== 'object' ||
      b === null
    ) {
      return false
    }

    const keysA = Object.keys(a)
    const keysB = Object.keys(b)

    if (keysA.length !== keysB.length) {
      return false
    }

    // If both objects have no keys, consider them equal
    if (keysA.length === 0 && keysB.length === 0) {
      continue
    }

    for (const key of keysA) {
      if (!keysB.includes(key)) {
        return false
      }
      stack.push([a[key], b[key]])
    }
  }

  return true
}

export const hasValue = (value: any) => {
  return Array.isArray(value)
    ? value.length > 0
    : !isNull(value) && !isUndefined(value) && value !== ''
}

export const guid = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
